import axios from 'axios'

// API configuration object
let apiConfig = {
  baseURL: null,
  tenantId: null,
  timeout: 0 // Infinite timeout by default, can be overridden by config.searchTimeout in configureApi
}

/**
 * Configure API with mfConfig and realm from App.vue
 * This should be called during app initialization
 */
export function configureApi(config, realm) {
  if (config?.api) {
    apiConfig.baseURL = config.api
  }
  if (realm) {
    apiConfig.tenantId = realm
  }
  if (config?.searchTimeout != null) {
    apiConfig.timeout = config.searchTimeout
  }
}

/**
 * Get current API configuration
 */
export function getApiConfig() {
  return { ...apiConfig }
}

// Create axios instance with dynamic config
const getApiClient = () => {
  if (!apiConfig.baseURL) {
    console.error('[Data Discovery API] baseURL not configured. Call configureApi first.')
  }
  if (!apiConfig.tenantId) {
    console.error('[Data Discovery API] tenantId not configured. Call configureApi first.')
  }

  return axios.create({
    baseURL: apiConfig.baseURL,
    timeout: apiConfig.timeout,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true
  })
}

// Request interceptor
const setupInterceptors = (apiClient) => {
  apiClient.interceptors.request.use(
    (config) => {
      // Add auth token if needed
      // const token = localStorage.getItem('token')
      // if (token) {
      //   config.headers.Authorization = `Bearer ${token}`
      // }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Response interceptor
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle common errors
      if (error.response) {
        // Server responded with error status
        console.error('API Error:', error.response.status, error.response.data)
      } else if (error.request) {
        // Request was made but no response received
        console.error('Network Error:', error.message)
      } else {
        // Something else happened
        console.error('Error:', error.message)
      }
      return Promise.reject(error)
    }
  )
}

export default {
  /**
   * Search for datasets
   * API: GET /api/v3/{tenantId}/discovery
   * @param {string} query - Search query
   * @param {Object} options - Search options
   * @param {boolean} options.deepSearch - Enable deep search
   * @returns {Promise} API response
   */
  searchDatasets(query, options = {}) {
    const apiClient = getApiClient()
    setupInterceptors(apiClient)

    const endpoint = `${apiConfig.tenantId}/discovery`

    return apiClient.get(endpoint, {
      params: {
        query,
        deep: options.deepSearch || false,
      }
    })
  },

  /**
   * Get file preview/details
   * API: POST /api/v3/{tenantId}/discovery/preview
   * @param {Object} payload - Preview request payload
   * @param {string} payload.url - File URL to preview
   * @param {string} payload.source - Source URL of the dataset
   * @param {string} payload.dataset_url - Dataset URL
   * @param {string} payload.format - File format (e.g., 'csv', 'json', 'xlsx')
   * @returns {Promise} API response
   */
  getFilePreview(payload) {
    const apiClient = getApiClient()
    setupInterceptors(apiClient)

    const endpoint = `${apiConfig.tenantId}/discovery/preview`

    return apiClient.post(endpoint, {
      url: payload.url,
      source: payload.source,
      dataset_url: payload.dataset_url,
      format: payload.format
    })
  },

  /**
   * Get file details (alias of preview)
   * @param {Object} payload - Preview request payload
   * @returns {Promise} API response
   */
  getFileDetails(payload) {
    return this.getFilePreview(payload)
  },
}
